import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import { getThreeDCBase, getThreeDCTargets, saveThreeDCTargets } from "./threeDCConfig";
import "./ThreeDC.scss";

function ThreeDCSettings() {
  const navigate = useNavigate();
  const [targets, setTargets] = useState(getThreeDCTargets);
  const [saved, setSaved] = useState(false);

  const update = (field, value) => {
    setSaved(false);
    setTargets((current) => ({ ...current, [field]: value }));
  };

  const save = (event) => {
    event.preventDefault();
    const normalized = saveThreeDCTargets(targets);
    setTargets(normalized);
    setSaved(true);
  };

  return (
    <main className="page-container threedc-page threedc-settings-page">
      <header className="threedc-header">
        <div>
          <span className="threedc-eyebrow">3D C configuration</span>
          <h1>Consumer Intelligence API</h1>
          <p>The interface is bundled with PaiyHub. Choose the PHP backend used for workflows, analysis, history, and reporting.</p>
        </div>
        <button type="button" className="threedc-button" onClick={() => navigate("/3dc")}>
          <ArrowBackIcon fontSize="small" /> Back to 3D C
        </button>
      </header>

      <form className="threedc-settings-card" onSubmit={save}>
        <label>
          Active environment
          <select value={targets.environment} onChange={(event) => update("environment", event.target.value)}>
            <option value="local">Local PHP API</option>
            <option value="test">Dev2 Lab</option>
            <option value="production">Production</option>
          </select>
        </label>

        <label>
          Local API URL
          <input value={targets.local} onChange={(event) => update("local", event.target.value)} />
        </label>

        <label>
          Dev2 Lab API URL
          <input value={targets.test} onChange={(event) => update("test", event.target.value)} />
        </label>

        <label>
          Production API URL
          <input value={targets.production} onChange={(event) => update("production", event.target.value)} />
        </label>

        <div className="threedc-target-preview">
          <span>Active backend API</span>
          <strong>{getThreeDCBase(targets)}</strong>
        </div>

        <div className="threedc-settings-actions">
          {saved && <span className="threedc-saved">Target saved.</span>}
          <button type="submit" className="threedc-button primary">
            <SaveIcon fontSize="small" /> Save target
          </button>
        </div>
      </form>
    </main>
  );
}

export default ThreeDCSettings;
